/**
 * Hariom ERP - Main Application Layout
 * Wraps all authenticated pages with sidebar + header
 * Handles responsive behavior between mobile and desktop
 */
import React, { useState } from 'react'
import { Outlet } from 'react-router-dom'
import Sidebar from './Sidebar'
import Header from './Header'

const AppLayout: React.FC = () => {
  // Controls mobile sidebar open/close state
  const [sidebarOpen, setSidebarOpen] = useState(false)

  return (
    <div className="flex h-screen overflow-hidden bg-steel-50">
      {/* ===== Left Sidebar ===== */}
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      {/* ===== Main Content Area ===== */}
      {/* lg:ml-64 = offset for sidebar width on desktop */}
      <div className="flex-1 flex flex-col min-w-0 lg:ml-64 transition-all duration-300">
        {/* Top Header */}
        <Header onMenuToggle={() => setSidebarOpen(true)} />

        {/* Page Content - scrollable area */}
        <main className="flex-1 overflow-y-auto p-4 md:p-6 animate-fade-in">
          {/* Outlet renders the current route's page component */}
          <Outlet />
        </main>
      </div>
    </div>
  )
}

export default AppLayout
